export default {
      id: "graph-vhsl-usage",
      viewBox: "0 0 178 130",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-vhsl",
      toString: function () {
        return this.url;
      }
    }